import {IMuWidget} from "./IMuWidget";

export class BaseMuWidget extends IMuWidget {
	public closeModal(sender : HTMLElement|string) {
		//todo: Nové MuWidget
		if (typeof sender === "string") sender = this.ui[sender];
		while(sender && !sender.classList.contains('modal-b')) sender = sender.parentElement;
		sender.style.display = 'none';
	}
}